module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-nginx-03.907fbb5072945adb5320aea5ec0f8742.png";